export default __webpack_public_path__ + "static/media/id.24dc86d9.svg";